import {isPlayerAction, isRemovePlayerEvent, PlayerId, Projection, SharedGameState} from '@glark-newco/game-library';
import {networkStore, NodeId} from './networkStore';
import {isAssignLinkPayload, isAssignPlayerNodePayload} from '../SupplyChainPayloadTypes';

export interface PlayerLink {
    playerA: PlayerId;
    playerB: PlayerId;
    relationship: 'local' | 'remote';
}

export interface NetworkSlice extends SharedGameState {
    playNetworkActive?: boolean;
}

export const networkProjection: Projection<NetworkSlice> = {
    name: 'networkProjection',
    project: (state, newEvents) => {
        let  playNetworkActive = state.playNetworkActive ?? false;
        networkStore.getState().updateNetwork((draft) => {
            newEvents.forEach(ev => {
                if (isPlayerAction(ev)) {
                    if (isAssignPlayerNodePayload(ev.payload)) {
                        if (!playNetworkActive) {
                            // First AssignPlayerNodePayload in this round → wipe any DESIGN network
                            draft.nodes = {};
                            draft.links = [];
                            draft.ownership = {};
                            playNetworkActive = true;
                        }

                        const payload = ev.payload;
                        const nodeId: NodeId =
                            Math.max(0, ...Object.keys(draft.nodes).map(k => parseInt(k))) + 1;

                        draft.nodes[nodeId] = {
                            id: nodeId,
                            x: payload.x,
                            y: payload.y,
                        };
                        draft.ownership[nodeId] = payload.playerId;

                    } else if (isAssignLinkPayload(ev.payload)) {
                        const {playerA, playerB, relationship} = ev.payload;
                        
                        const findNodeId = (pid: PlayerId) =>
                            Object.entries(draft.ownership).find(([, id]) => id === pid)?.[0];

                        const nodeA = findNodeId(playerA);
                        const nodeB = findNodeId(playerB);

                        if (nodeA && nodeB) {
                            const a = Number(nodeA);
                            const b = Number(nodeB);
                            if (!draft.links.some(l => (l.nodeIdA === a && l.nodeIdB === b) || (l.nodeIdA === b && l.nodeIdB === a))) {
                                draft.links.push({nodeIdA: a, nodeIdB: b, relationship});
                            }
                        }
                    }
                }
                
                if (isRemovePlayerEvent(ev)) {
                    const {removePlayerId, replacementId} = ev;
                    
                    Object.keys(draft.ownership).forEach(nodeIdStr => {
                        const nodeId = Number(nodeIdStr);
                        if (draft.ownership[nodeId] === removePlayerId) {
                            if (replacementId) {
                                draft.ownership[nodeId] = replacementId;
                            } else {
                                delete draft.ownership[nodeId];
                            }
                        }
                    });
                }
            });
        });

        return {playNetworkActive};
    },
    reset: () => {
        // console.trace('Resetting network state');
        networkStore.setState({nodes: {}, links: [], ownership: {}}, false);
        return {playNetworkActive: false};
    },
};
